import React, {useEffect, useState} from 'react';
import './style.scss'
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

export default function UsersList(props) {
    const [users, setUsers] = useState([]);

    function onUserClick(userId) {
        if (props.onUserSelect)
            props.onUserSelect(userId)
    }

    useEffect(() => {
        setUsers([...props.users].sort((a, b) => a.name.localeCompare(b.name)));
    }, [props.users]);

    return (
        <div className="users-list">
            <List>
                {users.map(user => (
                    <ListItem button
                              key={user.id}
                              onClick={() => onUserClick(user.id)}
                              className={"user-container" + (props.selectedUserId === user.id ? " user-container-selected" : "")}
                    >
                        <ListItemText primary={user.name}/>
                    </ListItem>
                ))}
            </List>
        </div>
    );
}